<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

select:disabled, input:disabled {
  background-color: #F8FAFC;
}

</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Neuer Sensor
        </template>
        
        <div v-visible="loading" class="progress progress-sm mb-0 mt-0">
            <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
        </div>
        
        <div v-show="show.sensorTypeList" class="row mt-3 mb-2" :class="{'text-muted': show.newSensor}">
            <div class="col-12">
                <label class="form-label">Auswahl der Sensorart</label>
                <select v-model="sensorTypeId" class="form-select" :disabled="loading">
                    <option :value="null">
                        <span v-if="sensorTypeList.length === 0">
                            Verfügbare Sensorarten werden abgerufen ...
                        </span>
                        <span v-else>
                            Bitte wählen
                        </span>
                    </option>
                    <option v-for="option in sensorTypeList" :key="option.id" :value="option.id">
                        {{ option.label }}
                    </option>
                </select>
            </div>           
        </div>
        
        <transition name="fade" @after-enter="$refs.sensorProviderId.focus()">
        <div v-show="show.sensorProviderList" class="row mt-3 mb-2" :class="{'text-muted': show.newSensor}">
            <div class="col-12">
                <label class="form-label">Auswahl des Anbieters</label>
                <select ref="sensorProviderId" v-model="sensorProviderId" :disabled="loading" class="form-select" >
                    <option :value="null">Bitte wählen</option>
                    <option v-for="option in sensorProviderList" :key="option.id" :value="option.id" :disabled="!option.isAvailable">
                        {{ option.label }} {{ option.isAvailable ? '' : '(Anbieter momentan nicht erreichbar)' }}
                    </option>
                </select>
            </div>           
        </div>
        </transition>
        
        <Alert type="info" :show="alert.infoCredentials" >
            <template v-slot:title>Anmelden beim Anbieter</template>
            Um Ihre Sensoren in die App einzubinden, müssen Sie sich einmalig mit Ihren Zugangsdaten 
            anmelden. Bitte geben Sie dazu Benutzername und Passwort an, mit denen sie sich im Portal des 
            Anbieter einloggen.
        </Alert>
        
        <Alert type="danger" :show="alert.incorrectCredentials" >
            <template v-slot:title>Zugangsdaten nicht korrekt</template>
            Die von Ihnen angegeben Zugangsdaten sind nicht korrekt. Bitte überprüfen Sie Benutzername und Passwort, 
            die Sie vom Anbieter erhalten haben und versuchen Sie es erneut. Sollte die Anmeldung trotzdem scheitern, 
            wenden Sie sich bitte an den Anbieter oder direkt an uns.
        </Alert>
        
        <transition name="fade"  @after-enter="$refs.username.focus()">
        <div v-show="show.credentials" class="row mt-3 mb-2" :class="{'text-muted': show.newSensor}">
            <div class="col-6">
                <label class="form-label">Benutzername</label>
                <input ref="username" type="text" v-model="username" class="form-control" name="example-text-input" placeholder="Username">
            </div> 
            <div class="col-6">
                <label class="form-label">Passwort</label>
                <input type="text" v-model="password" class="form-control" name="example-text-input" placeholder="Passwort">
            </div>      
        </div>
        </transition>
        
        <transition name="fade">
        <div v-show="show.credentials" class="row mt-3 mb-2">
            <div class="col-12">
                <button type="button" class="btn form-control btn-info" @click="acquireCredentials()">Beim Anbieter anmelden</button>
            </div>           
        </div>
        </transition>
        
        <transition name="fade" @after-enter="$refs.sensorId.focus()">
        <div v-show="show.sensorList" class="row mt-3 mb-2" :class="{'text-muted': show.newSensor}">
            <div class="col-12">
                <label class="form-label">Auswahl des Sensors des Anbieters</label>
                <select ref="sensorId" v-model="sensorId" :disabled="loading" class="form-select" @change="$refs.sensorLabel.focus()" >
                    <option :value="null">
                        <span v-if="allSensorsEmbedded">
                            Alle verfügbaren Sensoren bereits eingebunden
                        </span>
                        <span v-else>
                            Bitte wählen
                        </span>
                    </option>
                    <option v-for="option in sensorList" :key="option.id" :value="option.id" :disabled="option.isEmbedded" :title="option.isEmbedded ? 'Sensor bereits eingebunden': null">
                        {{ option.label }} {{ option.isEmbedded ? '(Sensor bereits eingebunden)' : '' }}
                    </option>
                </select>
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.noSensors" >
            <template v-slot:title>Keine Sensoren</template>
            Für den gewählten Sensortyp und Anbieter konnten keine Sensoren gefunden werden. Bitte wählen Sie einen 
            anderen Sensortyp bzw. Anbieter oder richten Sie die gewünschte Sensorik beim Anbieter ein.
        </Alert>
        
        <transition name="fade" @after-enter="$refs.sensorLabel.focus()">
        <div v-show="show.newSensor" class="row mt-3 mb-2" >
            <div class="col-12">
                <label class="form-label">Sensorbezeichnung in der App</label>
                <input ref="sensorLabel" type="text" v-model="sensorLabel" class="form-control" name="example-text-input" placeholder="Name des Sensors">
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.emptySensorLabel" :timeout="3000">
            <template v-slot:title>Sensorbezeichnung fehlt</template>
            Bitte geben Sie einen aussagekräftigen Namen für die Sensorbezeichnung in der App an. 
        </Alert>
        
        <ShareSensor v-if="show.newSensor" v-model:sharedUserIds="sensorSharedUserList" v-model:loading="loading"></ShareSensor>
        
        <div v-show="show.newSensor && false" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Datenimport in die Bewässerungs-App</label>
                <ButtonCheckBox v-model:checked="sensorActive" >
                    <template v-slot:isChecked>Täglichen Datenimport deaktivieren</template>
                    Täglichen Datenimport aktivieren
                </ButtonCheckBox>
            </div>           
        </div>
        
        <template v-slot:footer>
            <button class="btn btn-light link-secondary" @click="closeModal" >
              Abbrechen
            </button>
            <button class="btn ms-auto" :class="{ 'btn-info': show.newSensor, 'btn-light': !show.newSensor}" @click="submit">
              <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    Sensor einbinden
            </button>
        </template>
    </Modal>
</template>

<script>
import axios from 'axios';
import * as dayjs from 'dayjs';

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import ShareSensor from '@/components/sensor/ShareSensor.vue';
import ButtonCheckBox from '@/components/input/ButtonCheckBox.vue';

export default {
    name: 'New Sensor Modal',
    components: {
        Modal,
        Alert,
        ShareSensor,
        ButtonCheckBox
    },
    inject: [
        'state',
        'config'
    ],
    props: {
       
    },
    data: function () {
        return {
            username: null,
            password: null,
            sensorTypeId: null,
            sensorTypeList: [],
            sensorProviderId: null,
            sensorProviderList: [],
            sensorId: null,
            sensorList: [],
            sensorLabel: '',
            sensorSharedUserList: [],
            sensorActive: true,
            show: {
                sensorTypeList: true,
                sensorProviderList: false,
                sensorList: false,
                credentials: false,
                newSensor: false
            },
            alert: {
                noSensors: false,
                emptySensorLabel: false,
                infoCredentials: false,
                incorrectCredentials: false
            },
            loading: false           
        }
    },
    computed: {
        provider: function() {
            return this.getListItemById(this.sensorProviderList, this.sensorProviderId);
        },
        sensor: function() {
            return this.getListItemById(this.sensorList, this.sensorId);
        },
        allSensorsEmbedded: function() {
            return this.sensorList.length > 0 && this.sensorList.filter( function(sensor){
                return sensor.isEmbedded === false;
            }).length === 0;
        }
    },
    methods: {
        submit: function () {
            if (this.validateForm()) {
                this.$emit('addSensor', {
                    providerId: this.sensorProviderId,
                    providerSensorId: this.sensorId,
                    label: this.sensorLabel,
                    sharedUserIds: this.sensorSharedUserList,
                    isActive: this.sensorActive
                });
            }
        },
        openModal: function () {
            this.fetchProviders();
            this.$refs.modal.openModal();            
        },
        closeModal: function () {
            this.$refs.modal.closeModal();            
        },
        validateForm: function () {
           const self = this;
           self.alert.emptySensorLabel = false;
            
           if ( String(self.sensorLabel).trim() === '' ) {
                self.$nextTick(function() { 
                    self.alert.emptySensorLabel = true;
                });
                return false;
           }
                       
           return true;
        },
        getListItemById: function(list, id) {
            return list.reduce( function(accumulator, currentValue) {
                if (currentValue.id === id) {
                    return currentValue;
                } else {
                    return accumulator;
                }
            }, {});
        },
        setListItemById: function(list, id, item) {
            list.forEach( function(_item, index) {
                if (_item.id === id ) {
                    list[index] = item;
                }
            });    
        },
        acquireCredentials: function(callback) {
            this.alert.infoCredentials = false;
            this.alert.incorrectCredentials = false;
            
            if (this.username.trim() === '' || this.password.trim() === '') {
                this.$nextTick(function() { 
                    this.alert.incorrectCredentials = true;
                });
                return false;
            }
        
            let self = this;
            
            let query = {
                query: `
                    mutation (
                        $providerId: String!
                        $username: String!
                        $password: String!
                        $parameterId: String
                    ) {
                        acquireSensorproviderCredentials (
                        providerId: $providerId
                        username: $username
                        password: $password ) {
                            sensors {
                                providers (providerId: $providerId) {
                                    id
                                    label
                                    isAuthenticated
                                    sensors (parameterId: $parameterId) {
                                        id: providerSensorId
                                        label
                                        parameterId
                                        isEmbedded
                                    }
                                }
                            }
                        }
                    }
                `,      
                variables: {
                    providerId: self.sensorProviderId,
                    username: self.username,
                    password: self.password,
                    parameterId: self.sensorTypeId
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    const provider = data.acquireSensorproviderCredentials.sensors.providers[0];
                
                    self.setListItemById(
                        self.sensorProviderList, 
                        self.sensorProviderId, 
                        provider
                    );
                    
                    self.sensorList = provider.sensors;
                    
                    self.show.credentials = false;
                    
                    if (self.sensorList.length > 0) {
                        self.show.sensorList = true;
                    } else {
                        self.alert.noSensors = true;
                    }
                },
                function(errors){
                    const standardErrorHandler = false;
                
                    errors.forEach( function(item) {
                        if (item.type && item.type === 'CredentialError' ) {
                            self.alert.incorrectCredentials = true;
                            self.$refs.username.focus();
                        } else {
                            response.standardErrorHandler(errors);
                        }
                    });
                    
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
               
                if (callback) {
                    callback(self);
                }
            });
        },
        fetchProviders: function(callback) {
            
            let self = this;
            
            let query = {
                query: `
                    query {
                        sensors {
                            types {
                                id
                                label
                            }
                            providers {
                                id
                                label
                                isAvailable
                                isAuthenticated
                            }
                        }
                    }
                `,      
                variables: {
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.sensorTypeList = data.sensors.types;
                    self.sensorProviderList = data.sensors.providers;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        
        },
        fetchSensors: function (callback) {
            
            const self = this;
            
            let query = {
                query: `
                query (
                    $providerId: String
                    $parameterId: String
                    ) {
                    sensors {
                        providers (providerId: $providerId) {
                            id
                            label
                            sensors (parameterId: $parameterId) {
                                id: providerSensorId
                                label
                                parameterId
                                isEmbedded
                            }
                        }
                    }
                }  
                `,      
                variables: {
                    providerId: self.sensorProviderId,
                    parameterId: self.sensorTypeId
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.sensorList = data.sensors.providers[0].sensors;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        
        },
        showAddSensorSharedUser: function () {
            this.show.newSensorSharedUserId = true;
        },
        hideAddSensorSharedUser: function () {
            this.show.newSensorSharedUserId = false;
        },
        addSensorSharedUser: function () {
            alert('add');
        }
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        sensorTypeId: function(new_value, old_value) {
            const self = this;
            
            self.sensorProviderId = null;
            self.sensorId = null;
            
            self.show.newSensor = false;
            self.show.credentials = false;
            self.alert.noSensors = false;
            
            if (new_value) {
                self.show.sensorProviderList = true;
            } else {
                self.show.sensorProviderList = false;
            }
        },
        sensorProviderId: function(new_value, old_value) {
            const self = this;
            
            self.sensorId = null;
            
            self.show.newSensor = false;
            self.show.credentials = false;
            
            self.alert.infoCredentials = false;
            self.alert.incorrectCredentials = false;
            self.alert.noSensors = false;
            
            if (new_value) {
            
                if (self.provider.isAuthenticated === false) {
                    self.alert.infoCredentials = true;
                    self.show.credentials = true;
                    self.username = '';
                    self.password = '';
                    return;
                } else {
                    self.fetchSensors(function() {
                    
                        if (self.sensorList.length > 0) {
                            self.show.sensorList = true;
                        } else {
                            self.alert.noSensors = true;
                        }
                       
                    });
                }
            } else {
                self.show.sensorList = false;
            }
        },
        sensorId: function(new_value, old_value) {
            const self = this;
            if (new_value) {
                self.show.newSensor = true;
                self.sensorLabel = this.sensor.label;
            } else {
                self.sensorLabel = '';
                self.show.newSensor = false;
            }
        },
        sensorSharedUserId: function(new_value, old_value) {
            const self = this;
            
            if (new_value) {
                self.show.addSensorSharedUserId = false;
                self.show.removeSensorSharedUserId = true;
            } else {
                self.show.addSensorSharedUserId = true;
                self.show.removeSensorSharedUserId = false;
            }
            
            self.show.newSensorSharedUserId = false;
        }
    },
    created: function() {
        
    },
    mounted: function() {
        
    }
}
</script>

